<ng-container *ngIf="!isLoading">
  <div class="time">
    <div class="start-time">{{ event.startTime }}</div>
    <div *ngIf="showEndTime()" class="end-time">{{ event.endTime }}</div>
  </div>

  <div class="separator color-separator"></div>

  <div class="main-content">
    <div class="title">
      <a *ngIf="event.link" href="{{event.link}}" target="_blank">{{ event.title }}</a>
      <div *ngIf="!event.link">{{ event.title }}</div>
    </div>

    <div class="separator"></div>

    <div class="details">
      <div class="details-description">{{ event.description }}</div>

      <div *ngIf="event.location && !event.sendToDate" class="details-item">
        <mat-icon [svgIcon]="'location'" class="square-icon details-item-icon"></mat-icon>
        <span *ngIf="event.gpsX; else locationMapText">
          <a (click)="locatinPicker.openMapsModal()">{{event.location}}</a>
        </span>
        <ng-template #locationMapText>
          <div>
            {{event.location}}
          </div>
        </ng-template>
      </div>

      <div *ngIf="event.sendToDate" class="details-item">
        <mat-icon [svgIcon]="'clock'" class="square-icon details-item-icon"></mat-icon>
        {{ submissionLabel }} {{ event.date | date: 'd/MM' }}, {{atHourLabel}} {{ event.date | date: 'h:mm' }}
      </div>      
    </div>
  </div>

  <div class="separator"></div>

  <div class="notifications">
    <a *ngIf="event.notifications && event.notifications.length" class="notification-link" (click)="openNotificationClick($event)"> 
      <mat-icon [svgIcon]="'bell-point'" class="notification-icon"></mat-icon>
    </a>
    <a *ngIf="event.type === StudentDataType.Event" href="{{event.link}}" class="notification-link">
      <mat-icon [svgIcon]="'calendar-current-point'" class="square-icon calendar-icon"></mat-icon>
    </a>
  </div>

  <app-location-select-picker #locatinPicker [gpsX]="event.gpsX" [gpsY]="event.gpsY" />

  <app-lesson-notifications *ngIf="openedNotifications" [notifications]="event.notifications" [headerText]="notificationHeader" (close)="closeNotifications()" />
</ng-container>

<ng-container *ngIf="isLoading">
  <app-skeleton [height]="85"></app-skeleton>
</ng-container>